import { PaginatedData } from '@robocorp/robocloud-common/lib/types';
import { WithWorkspaceId } from '~/types/common';
import { AssistantRun } from '~/types/resources';
import { integrationAssistantApi } from '~/utils/api';

export const getAssistantRun = async ({
  workspaceId,
  assistantId,
  runId,
}: { assistantId: string; runId: string } & WithWorkspaceId) =>
  integrationAssistantApi.get<AssistantRun>(
    `/workspaces/${workspaceId}/assistants/${assistantId}/runs/${runId}`,
  );

export const deleteAssistantRun = async ({
  workspaceId,
  assistantId,
  runId,
}: { assistantId: string; runId: string } & WithWorkspaceId) =>
  integrationAssistantApi.delete<AssistantRun>(
    `/workspaces/${workspaceId}/assistants/${assistantId}/runs/${runId}`,
  );

export const listAssistantRuns = async ({
  workspaceId,
  assistantId,
  pageCursor,
}: { assistantId: string; pageCursor?: string | null } & WithWorkspaceId) =>
  integrationAssistantApi.get<PaginatedData<AssistantRun[]>>(
    `/workspaces/${workspaceId}/assistants/${assistantId}/runs`,
    {
      cursor: pageCursor,
    },
  );

export const listWorkspaceAssistantRuns = async ({ workspaceId }: WithWorkspaceId) =>
  integrationAssistantApi.get<AssistantRun[]>(`/workspaces/${workspaceId}/runs`);
